var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelActionsSendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 7.941,
    y: 7.941,
    fill: "#59E151",
    rx: 5,
    transform: "rotate(45 31.941 31.941)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 8.5c.414 0 .79.168 1.06.44.238.237.396.554.432.907L27.5 10v12c0 .414-.168.79-.44 1.06-.237.238-.554.396-.907.432L26 23.5H6c-.414 0-.79-.168-1.06-.44-.238-.237-.396-.554-.432-.907L4.5 22V10c0-.414.168-.79.44-1.06.237-.238.554-.396.907-.432L6 8.5h20zm.5 1.782l-10.243 6.147-.077.036c-.134.046-.288.023-.464-.052h0L5.5 10.283V22.5h21V10.282zm-.64-.782H6.14L16 15.416 25.86 9.5z",
    transform: "translate(16 16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelActionsSendEmail);
export default __webpack_public_path__ + "static/media/illustrations-funnel-actions-send-email.78e81218.svg";
export { ForwardRef as ReactComponent };